module.exports = __webpack_public_path__ + "img/129.55837598.svg";